module.exports = __webpack_public_path__ + "media/assets/stores/amazon-d204e6bb2d3bed7777696637f7a87651.png";